import type { ComponentProps } from 'react';
import { FormattedMessage } from 'react-intl';

import { SortingOption } from '@sorare/core/src/__generated__/globalTypes';
import { FilterInDropdown } from '@sorare/core/src/atoms/dropdowns/FilterInDropdown';
import { RadioGroup } from '@sorare/core/src/atoms/inputs/RadioGroup';

import { SelectHeader } from '#src/atoms/SelectHeader/index.tsx';

type Props = {
  value: SortingOption;
  onChange: (orderBy: SortingOption) => void;
} & Pick<
  ComponentProps<typeof FilterInDropdown>,
  'buttonColor' | 'fullWidth' | 'buttonSize' | 'blur'
>;

const labels = {
  [SortingOption.DESC]: <FormattedMessage defaultMessage="Latest" />,

  [SortingOption.ASC]: <FormattedMessage defaultMessage="Oldest" />,
};

export const SelectSort = ({
  value,
  onChange,
  buttonSize = 'small',
  fullWidth = false,
  buttonColor = 'tertiary',
  blur = false,
}: Props) => {
  const options = [SortingOption.DESC, SortingOption.ASC].map(sort => ({
    label: labels[sort],
    value: sort,
  }));

  return (
    <FilterInDropdown
      buttonLabel={labels[value]}
      buttonSize={buttonSize}
      buttonColor={buttonColor}
      fullWidth={fullWidth}
      blur={blur}
    >
      {({ closeDropdown }) => (
        <>
          <SelectHeader>
            <FormattedMessage defaultMessage="Select order" />
          </SelectHeader>
          <RadioGroup
            modalSelect
            options={options}
            value={value}
            name="rarity-selector"
            onChange={rarity => {
              onChange(rarity);
              closeDropdown();
            }}
          />
        </>
      )}
    </FilterInDropdown>
  );
};
